import React, { FC } from 'react'

import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

type SeactionHeaderProps = {
  title: React.ReactNode
}

const SeactionHeader: FC<SeactionHeaderProps> = ({ title }) => {
  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <Box mt={1} mb={2}>
        <Divider />
      </Box>
    </>
  )
}

export default SeactionHeader
